
import { Component, Vue } from 'vue-property-decorator';
import CampaignParticipantById from '@/pages/campaigns/_id/participants/_id.vue';
@Component({
  components: {
    CampaignParticipantById
  }
})
export default class ParticipantById extends Vue {}
